export const SUCCESSFUL_SIGN_UP_PARAM = 'successfulSignUp'
